import { filter } from 'lodash-es';
import { httpInsightsReporting } from '../../core/services/http';

export const loadHaulerLocationsForMapbox = (vendorLocationTypes?: string, includeInactiveFacilities?: boolean) =>
  httpInsightsReporting
    .get(`dashboard/hauler-locations`, {
      params: { locationTypeIds: vendorLocationTypes, includeInactiveFacilities },
    })
    .then(response => filter(response.data, r => r.customerSubTypeId !== null));
